import { useEffect, useState, useContext } from "react";
import { Container } from "react-bootstrap";
import axios from "axios";
import { LanguageContext } from "../components/context/LanguageContext";

const PrivacyPolicy = () => {
  const { language } = useContext(LanguageContext); // Get selected language
  const [privacy, setPrivacy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
console.log(language)
  useEffect(() => {
    setLoading(true);
    axios
    .get(`https://dev-api.rimligtaxi.se/api/v1/privacy-policy?language_type=${language}`)// Pass language in API request
      .then((response) => {
        setPrivacy(response?.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [language]); // Re-fetch data when language changes

  // if (loading) return <Container>Loading...</Container>;
  // if (error) return <Container>Error: {error}</Container>;

  return (
    <div className="static_contnet">
      <Container>
        <h2 className="subTitle text-center">{language === "en" ? "Privacy Policy" : "Integritetspolicy"}</h2>
        <div dangerouslySetInnerHTML={{ __html: privacy }} />
      </Container>
    </div>
  );
};

export default PrivacyPolicy;
